import { ITransportador } from "../Transportador";
import * as Sentry from "@sentry/angular-ivy";
import { PayloadError } from "../PayloadError";
import { LogTipos } from "../Utilidades";
import { environment } from "../../../../../environments/environment";

export class SentryTransportador implements ITransportador {

    public escribir(payload: PayloadError, tipo: LogTipos): void {
        if ((!environment.production && !environment.staging) || environment.version === "VERSION_NUMBER") {
            return;
        }
        if (payload.mensaje.includes("codigo 500")) {
            return;
        }

        switch (tipo) {
        case LogTipos.ERROR:
            Sentry.captureMessage(`Mensaje: ${payload.mensaje}\nStack: ${payload.stack}`, "error");
            break;
        case LogTipos.INFO:
            Sentry.captureMessage(`Mensaje: ${payload.mensaje}\nStack: ${payload.stack}`, "info");
            break;
        case LogTipos.WARNING:
            Sentry.captureMessage(`Mensaje: ${payload.mensaje}\nStack: ${payload.stack}`, "warning");
            break;
        case LogTipos.DEBUG:
            Sentry.captureMessage(`Mensaje: ${payload.mensaje}\nStack: ${payload.stack}`, "debug");
            break;
        }
    }

}
